module.exports = __webpack_public_path__ + "img/Vector (6).d26173ea.svg";